<template>
    <div class="card box widget-social pt-2 pb-2" :class="componentStyle">
        <widgetTitleBar :moduleData="this.moduleData" :widgetInfo="content" :alarmList="this.alarmList" :menu-items="this.items" @menu-click="($value) => this.toggle($value)"></widgetTitleBar>
        <OverlayPanel
            class="param-overlay"
            ref="alarmOverlay"
            appendTo="body"
            :autoZIndex="true"
            @show="focusElement" 
            :dismissable="true"
            :showCloseIcon="true"
            :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
            :style="{ height: 'auto' }"
        >
            <div v-for="(element) in this.alarmList" :key="element.label">
                <span>🔴 {{ element.label }}</span>
            </div>
        </OverlayPanel>
        <div v-if="isLoading">
            <loader-skeleton :widgetInfo="content"></loader-skeleton>
        </div>
        <OverlayPanel class="param-overlay" ref="periods" appendTo="body" :autoZIndex="true" @show="focusElement" 
            :dismissable="false" :showCloseIcon="true" :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
            :style="{ height: '300px' }">
        </OverlayPanel>
        <OverlayPanel ref="misc" appendTo="body" @show="focusElement" :dismissable="false">
        </OverlayPanel>
        <Dialog
            v-model:visible="showDiagMisc"
            @show="focusElement"
            :breakpoints="{ '960px': '85vw', '640px': '90vw' }"
            :style="{ width: '700px' }"
        >
            <template #header>
                <h5><i class="pi pi-cog">&nbsp;</i><span class="subtext mt-1">{{ moduleDepartment.key }} {{ moduleDepartment.label }} ⚡ Allgemeine Einstellungen</span></h5>
            </template>
            <div v-if="saveWait" class="flex justify-content-center flex-wrap">
                <ProgressSpinner
                style="width: 50px; height: 50px"
                strokeWidth="4"
                fill="var(--red-600)"
                animationDuration="1s"
                />
            </div>
            <div v-else @keydown.esc="hideOP" @keydown.enter="saveDiag('misc')">
                <loader v-if="dialogLoading" :style="'box'"></loader>
                <TabView :scrollable="true">
                    <TabPanel header="Sequenzeinstellungen" v-if="isMaster">
                        <Panel header="Wärmetauscher-Sequenzen" class="mt-3">
                            <template #icons>
                                <i class="fi fi-rr-temperature bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col-6">
                                    <div class="flex flex-column">
                                        <div class="flex align-items-center justify-content-center mb-2">
                                            <label for="wt1Seq" class="mr-0">{{ this.getDiagDataCfg('wt1Seq').label }}</label>
                                        </div>
                                        <div class="flex align-items-center justify-content-center">
                                            <Dropdown v-model="this.getDiagDataCfg('wt1Seq').value" ref="wt1Seq" :options="getHeatFwSeq" optionLabel="label" optionValue="value" placeholder="Sequenz" class="w-full" />
                                        </div>
                                    </div>
                                </div>
                                <div class="field col-6">
                                    <div class="flex flex-column">
                                        <div class="flex align-items-center justify-content-center mb-2">
                                            <label for="wt2Seq" class="mr-0">{{ this.getDiagDataCfg('wt2Seq').label }}</label>
                                        </div>
                                        <div class="flex align-items-center justify-content-center">
                                            <Dropdown v-model="this.getDiagDataCfg('wt2Seq').value" ref="wt2Seq" :options="getHeatFwSeq" optionLabel="label" optionValue="value" placeholder="Sequenz" class="w-full" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Reglereinstellungen" class="mt-3" v-if="isMaster">
                            <template #icons>
                                <i class="fi fi-rr-temperature bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="seq1Deadband" ref="seq1Deadband" :min="0" :max="100"
                                            v-model="getDiagDataCfg('seq1Deadband').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('seq1Deadband').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="seq1Deadband" class="mr-2">{{ getDiagDataCfg('seq1Deadband').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="seqTransition" ref="seqTransition" :min="0" :max="100"
                                            v-model="getDiagDataCfg('seqTransition').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('seqTransition').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="seqTransition" class="mr-2">{{ getDiagDataCfg('seqTransition').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="seqHiLoDelay" ref="seqHiLoDelay" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('seqHiLoDelay').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="seqHiLoDelay" class="mr-2">{{ getDiagDataCfg('seqHiLoDelay').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="seq2MinTime" ref="seq2MinTime" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('seq2MinTime').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="seq2MinTime" class="mr-2">{{ getDiagDataCfg('seq2MinTime').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="seq2MaxTime" ref="seq2MaxTime" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('seq2MaxTime').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="seq2MaxTime" class="mr-2">{{ getDiagDataCfg('seq2MaxTime').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Manueller Betrieb" class="mt-2">
                            <div class="formgrid grid p-1">
                                <div class="field col-6">
                                    <div class="field col flex justify-content-center">
                                        <div class="flex align-items-center mt-3">
                                            <InputSwitch v-model="this.getDiagDataCfg('wt1Manual').value" /><span class="ml-2">{{ this.getDiagDataCfg('wt1Manual').label }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="field col-6" v-if="this.getDiagDataCfg('wt1Manual').value">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="wt1ManualSet" ref="wt1ManualSet" :min="0" :max="100"
                                            v-model="getDiagDataCfg('wt1ManualSet').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('wt1ManualSet').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wt1ManualSet" class="mr-2">{{ getDiagDataCfg('wt1ManualSet').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1 mt-3">
                                <div class="field col-6">
                                    <div class="field col flex justify-content-center">
                                        <div class="flex align-items-center mt-3">
                                            <InputSwitch v-model="this.getDiagDataCfg('wt2Manual').value" /><span class="ml-2">{{ this.getDiagDataCfg('wt2Manual').label }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="field col-6" v-if="this.getDiagDataCfg('wt2Manual').value">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="wt2ManualSet" ref="wt2ManualSet" :min="0" :max="100"
                                            v-model="getDiagDataCfg('wt2ManualSet').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('wt2ManualSet').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wt2ManualSet" class="mr-2">{{ getDiagDataCfg('wt2ManualSet').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel> 
                    </TabPanel>
                    <TabPanel header="Stellantriebe" v-if="isMaster">
                        <Panel header="Temperaturgrenzen" class="mt-3">
                            <template #icons>
                                <i class="fi fi-rr-temperature bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="wt1MaxTemp" ref="wt1MaxTemp" :min="-100" :max="150"
                                            v-model="getDiagDataCfg('wt1MaxTemp').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('wt1MaxTemp').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wt1MaxTemp" class="mr-2">{{ getDiagDataCfg('wt1MaxTemp').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="wt2MaxTemp" ref="wt2MaxTemp" :min="-100" :max="150"
                                            v-model="getDiagDataCfg('wt2MaxTemp').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('wt2MaxTemp').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wt2MaxTemp" class="mr-2">{{ getDiagDataCfg('wt2MaxTemp').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="wtMaxTempAdd" ref="wtMaxTempAdd" :min="0" :max="150"
                                            v-model="getDiagDataCfg('wtMaxTempAdd').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('wtMaxTempAdd').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wtMaxTempAdd" class="mr-2">{{ getDiagDataCfg('wtMaxTempAdd').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Laufzeiten und Positionen" class="mt-3">
                            <template #icons>
                                <i class="fi fi-rr-clock bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="wt1Runtime" ref="wt1Runtime" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('wt1Runtime').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wt1Runtime" class="mr-2">{{ getDiagDataCfg('wt1Runtime').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="wt2Runtime" ref="wt2Runtime" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('wt2Runtime').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wt2Runtime" class="mr-2">{{ getDiagDataCfg('wt2Runtime').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="wt1MinPos" ref="wt1MinPos" :min="0" :max="100"
                                            v-model="getDiagDataCfg('wt1MinPos').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('wt1MinPos').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wt1MinPos" class="mr-2">{{ getDiagDataCfg('wt1MinPos').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="wt2MinPos" ref="wt2MinPos" :min="0" :max="100"
                                            v-model="getDiagDataCfg('wt2MinPos').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('wt2MinPos').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wt2MinPos" class="mr-2">{{ getDiagDataCfg('wt2MinPos').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="askOffDelay" ref="askOffDelay" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('askOffDelay').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="askOffDelay" class="mr-2">{{ getDiagDataCfg('askOffDelay').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Reglerparameter" class="mt-3">
                            <template #icons>
                                <i class="fi fi-rr-temperature bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="pFactorWt1" ref="pFactorWt1" :min="0.1" :max="100"
                                            v-model="getDiagDataCfg('pFactorWt1').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('pFactorWt1').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="pFactorWt1" class="mr-2">{{ getDiagDataCfg('pFactorWt1').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="pFactorWt2" ref="pFactorWt2" :min="0.1" :max="100"
                                            v-model="getDiagDataCfg('pFactorWt2').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('pFactorWt2').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="pFactorWt2" class="mr-2">{{ getDiagDataCfg('pFactorWt2').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="iFactorWt1" ref="iFactorWt1" :min="0" :max="10000"
                                            v-model="getDiagDataCfg('iFactorWt1').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('iFactorWt1').unit}`"
                                            :minFractionDigits="3" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="iFactorWt1" class="mr-2">{{ getDiagDataCfg('iFactorWt1').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="iFactorWt2" ref="iFactorWt2" :min="0" :max="10000"
                                            v-model="getDiagDataCfg('iFactorWt2').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('iFactorWt2').unit}`"
                                            :minFractionDigits="3" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="iFactorWt2" class="mr-2">{{ getDiagDataCfg('iFactorWt2').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="wt1Deadzone" ref="wt1Deadzone" :min="0.1" :max="100"
                                            v-model="getDiagDataCfg('wt1Deadzone').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('wt1Deadzone').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wt1Deadzone" class="mr-2">{{ getDiagDataCfg('wt1Deadzone').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="wt2Deadzone" ref="wt2Deadzone" :min="0" :max="10000"
                                            v-model="getDiagDataCfg('wt2Deadzone').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('wt2Deadzone').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wt2Deadzone" class="mr-2">{{ getDiagDataCfg('wt2Deadzone').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="wt1RuntimeFactor" ref="wt1RuntimeFactor" :min="0" :max="1000"
                                            v-model="getDiagDataCfg('wt1RuntimeFactor').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('wt1RuntimeFactor').unit}`"
                                            :minFractionDigits="3" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wt1RuntimeFactor" class="mr-2">{{ getDiagDataCfg('wt1RuntimeFactor').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="wt2RuntimeFactor" ref="wt2RuntimeFactor" :min="0" :max="1000"
                                            v-model="getDiagDataCfg('wt2RuntimeFactor').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('wt2RuntimeFactor').unit}`"
                                            :minFractionDigits="3" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wt2RuntimeFactor" class="mr-2">{{ getDiagDataCfg('wt2RuntimeFactor').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="deadBand" ref="deadBand" :min="0" :max="100"
                                            v-model="getDiagDataCfg('deadBand').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('deadBand').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="deadBand" class="mr-2">{{ getDiagDataCfg('deadBand').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="setpointPitch" ref="setpointPitch" :min="-100" :max="100"
                                            v-model="getDiagDataCfg('setpointPitch').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('setpointPitch').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="setpointPitch" class="mr-2">{{ getDiagDataCfg('setpointPitch').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="controlPauseTime" ref="controlPauseTime" :min="0" :max="100000"
                                            v-model="getDiagDataCfg('controlPauseTime').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('controlPauseTime').unit}`"
                                            :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="controlPauseTime" class="mr-2">{{ getDiagDataCfg('controlPauseTime').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="iFactorDelay" ref="iFactorDelay" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('iFactorDelay').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="iFactorDelay" class="mr-2">{{ getDiagDataCfg('iFactorDelay').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field col flex justify-content-center">
                                        <div class="flex align-items-center mt-3">
                                            <InputSwitch v-model="this.getDiagDataCfg('iFactorPosDiff').value" /><span class="ml-2">{{ this.getDiagDataCfg('iFactorPosDiff').label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="WT1 Antrieb analoge Funktion" class="mt-2">
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field col flex justify-content-center">
                                        <div class="flex align-items-center mt-3">
                                            <InputSwitch v-model="this.getDiagDataCfg('wt1OperateAnalog').value" /><span class="ml-2">{{ this.getDiagDataCfg('wt1OperateAnalog').label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Sensorskalierung WT1 Feedback" class="mt-3" v-if="this.getDiagDataCfg('wt1OperateAnalog').value === true">
                            <template #icons>
                                <i class="fi fi-rr-settings bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt1FeedbackInMin" ref="wt1FeedbackInMin" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('wt1FeedbackInMin').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt1FeedbackInMin" class="mr-2">Sensor IN Untergrenze</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt1FeedbackOutMin" ref="wt1FeedbackOutMin" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('wt1FeedbackOutMin').value"
                                                :suffix="` ${this.getDiagDataCfg('wt1FeedbackOutMin').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt1FeedbackOutMin" class="mr-2">Sensor OUT Untergrenze</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt1FeedbackInMax" ref="wt1FeedbackInMax" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('wt1FeedbackInMax').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt1FeedbackInMax" class="mr-2">Sensor IN Obergrenze</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt1FeedbackOutMax" ref="wt1FeedbackOutMax" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('wt1FeedbackOutMax').value"
                                                :suffix="` ${this.getDiagDataCfg('wt1FeedbackOutMax').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt1FeedbackOutMax" class="mr-2">Sensor OUT Obergrenze</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt1FeedbackOffset" ref="wt1FeedbackOffset" :min="-10000" :max="10000"
                                                v-model="this.getDiagDataCfg('wt1FeedbackOffset').value" mode="decimal"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt1FeedbackOffset" class="mr-2">Sensor Offset</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Analoger Ausgang WT1" class="mt-3" v-if="this.getDiagDataCfg('wt1OperateAnalog').value === true">
                            <template #icons>
                                <i class="fi fi-rr-settings bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt1SetpointInMin" ref="wt1SetpointInMin" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('wt1SetpointInMin').value"
                                                :suffix="` ${this.getDiagDataCfg('wt1SetpointInMin').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt1SetpointInMin" class="mr-2">Sensor IN Untergrenze</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt1SetpointOutMin" ref="wt1SetpointOutMin" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('wt1SetpointOutMin').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt1SetpointOutMin" class="mr-2">Sensor OUT Untergrenze</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt1SetpointInMax" ref="wt1SetpointInMax" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('wt1SetpointInMax').value"
                                                :suffix="` ${this.getDiagDataCfg('wt1SetpointInMax').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt1SetpointInMax" class="mr-2">Sensor IN Obergrenze</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt1SetpointOutMax" ref="wt1SetpointOutMax" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('wt1SetpointOutMax').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt1SetpointOutMax" class="mr-2">Sensor OUT Obergrenze</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt1FeedbackOffset" ref="wt1FeedbackOffset" :min="-10000" :max="10000"
                                                v-model="this.getDiagDataCfg('wt1FeedbackOffset').value" mode="decimal"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt1FeedbackOffset" class="mr-2">Sensor Offset</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="WT2 Antrieb analoge Funktion" class="mt-2">
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field col flex justify-content-center">
                                        <div class="flex align-items-center mt-3">
                                            <InputSwitch v-model="this.getDiagDataCfg('wt2OperateAnalog').value" /><span class="ml-2">{{ this.getDiagDataCfg('wt2OperateAnalog').label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Sensorskalierung WT2 Feedback" class="mt-3" v-if="this.getDiagDataCfg('wt2OperateAnalog').value === true">
                            <template #icons>
                                <i class="fi fi-rr-settings bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt2FeedbackInMin" ref="wt2FeedbackInMin" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('wt2FeedbackInMin').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt2FeedbackInMin" class="mr-2">Sensor IN Untergrenze</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt2FeedbackOutMin" ref="wt2FeedbackOutMin" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('wt2FeedbackOutMin').value"
                                                :suffix="` ${this.getDiagDataCfg('wt2FeedbackOutMin').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt2FeedbackOutMin" class="mr-2">Sensor OUT Untergrenze</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt2FeedbackInMax" ref="wt2FeedbackInMax" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('wt2FeedbackInMax').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt2FeedbackInMax" class="mr-2">Sensor IN Obergrenze</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt2FeedbackOutMax" ref="wt2FeedbackOutMax" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('wt2FeedbackOutMax').value"
                                                :suffix="` ${this.getDiagDataCfg('wt2FeedbackOutMax').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt2FeedbackOutMax" class="mr-2">Sensor OUT Obergrenze</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt2FeedbackOffset" ref="wt2FeedbackOffset" :min="-10000" :max="10000"
                                                v-model="this.getDiagDataCfg('wt2FeedbackOffset').value" mode="decimal"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt2FeedbackOffset" class="mr-2">Sensor Offset</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        
                        <Panel header="Analoger Ausgang WT2" class="mt-3" v-if="this.getDiagDataCfg('wt2OperateAnalog').value === true">
                            <template #icons>
                                <i class="fi fi-rr-settings bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt2SetpointInMin" ref="wt2SetpointInMin" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('wt2SetpointInMin').value"
                                                :suffix="` ${this.getDiagDataCfg('wt2SetpointInMin').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt2SetpointInMin" class="mr-2">Sensor IN Untergrenze</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt2SetpointOutMin" ref="wt2SetpointOutMin" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('wt2SetpointOutMin').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt2SetpointOutMin" class="mr-2">Sensor OUT Untergrenze</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt2SetpointInMax" ref="wt2SetpointInMax" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('wt2SetpointInMax').value"
                                                :suffix="` ${this.getDiagDataCfg('wt2SetpointInMax').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt2SetpointInMax" class="mr-2">Sensor IN Obergrenze</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt2SetpointOutMax" ref="wt2SetpointOutMax" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('wt2SetpointOutMax').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt2SetpointOutMax" class="mr-2">Sensor OUT Obergrenze</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt2FeedbackOffset" ref="wt2FeedbackOffset" :min="-10000" :max="10000"
                                                v-model="this.getDiagDataCfg('wt2FeedbackOffset').value" mode="decimal"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt2FeedbackOffset" class="mr-2">Sensor Offset</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                    </TabPanel>
                    <TabPanel header="RL-MAX Begrenzung">
                        <Panel header="Rücklauf Maximum Begrenzung verwenden" class="mt-2">
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field col flex justify-content-center">
                                        <div class="flex align-items-center mt-3">
                                            <InputSwitch v-model="this.getDiagDataCfg('wtMaxreturnEnable').value" /><span class="ml-2">{{ this.getDiagDataCfg('wtMaxreturnEnable').label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Panel> 
                        <Panel header="Rücklaufbegrenzung" class="mt-3">
                            <template #icons>
                                <i class="fi fi-rr-temperature bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="wtMaxreturnStart" ref="wtMaxreturnStart" :min="-100" :max="100"
                                            v-model="getDiagDataCfg('wtMaxreturnStart').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('wtMaxreturnStart').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wtMaxreturnStart" class="mr-2">{{ getDiagDataCfg('wtMaxreturnStart').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="wtMaxreturnEnd" ref="wtMaxreturnEnd" :min="-100" :max="100"
                                            v-model="getDiagDataCfg('wtMaxreturnEnd').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('wtMaxreturnEnd').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wtMaxreturnEnd" class="mr-2">{{ getDiagDataCfg('wtMaxreturnEnd').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="wtMaxreturnStartAT" ref="wtMaxreturnStartAT" :min="-100" :max="100"
                                            v-model="getDiagDataCfg('wtMaxreturnStartAT').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('wtMaxreturnStartAT').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wtMaxreturnStartAT" class="mr-2">{{ getDiagDataCfg('wtMaxreturnStartAT').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="wtMaxreturnEndAT" ref="wtMaxreturnEndAT" :min="-100" :max="100"
                                            v-model="getDiagDataCfg('wtMaxreturnEndAT').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('wtMaxreturnEndAT').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wtMaxreturnEndAT" class="mr-2">{{ getDiagDataCfg('wtMaxreturnEndAT').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Reglereinstellungen" class="mt-3" v-if="isMaster">
                            <template #icons>
                                <i class="fi fi-rr-temperature bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="wtMaxreturnPFactor" ref="wtMaxreturnPFactor" :min="0" :max="1000"
                                            v-model="getDiagDataCfg('wtMaxreturnPFactor').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('wtMaxreturnPFactor').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wtMaxreturnPFactor" class="mr-2">{{ getDiagDataCfg('wtMaxreturnPFactor').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="wtMaxreturnPFactorControl" ref="wtMaxreturnPFactorControl" :min="0" :max="100"
                                            v-model="getDiagDataCfg('wtMaxreturnPFactorControl').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('wtMaxreturnPFactorControl').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wtMaxreturnPFactorControl" class="mr-2">{{ getDiagDataCfg('wtMaxreturnPFactorControl').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="wtMaxreturnOverdrive" ref="wtMaxreturnOverdrive" :min="0" :max="100"
                                            v-model="getDiagDataCfg('wtMaxreturnOverdrive').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('wtMaxreturnOverdrive').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wtMaxreturnOverdrive" class="mr-2">{{ getDiagDataCfg('wtMaxreturnOverdrive').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="wtMaxreturnDelay" ref="wtMaxreturnDelay" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('wtMaxreturnDelay').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wtMaxreturnDelay" class="mr-2">{{ getDiagDataCfg('wtMaxreturnDelay').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel>
                    </TabPanel>
                    <TabPanel header="Primäre Spreizung" v-if="isMaster">
                        <Panel header="Spreizungsregelung verwenden" class="mt-2">
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field col flex justify-content-center">
                                        <div class="flex align-items-center mt-3">
                                            <InputSwitch v-model="this.getDiagDataCfg('wtPriControlEnable').value" /><span class="ml-2">{{ this.getDiagDataCfg('wtPriControlEnable').label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Panel> 
                        <Panel header="Rücklaufbegrenzung" class="mt-3">
                            <template #icons>
                                <i class="fi fi-rr-temperature bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="wtPriStartDiff" ref="wtPriStartDiff" :min="-100" :max="100"
                                            v-model="getDiagDataCfg('wtPriStartDiff').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('wtPriStartDiff').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wtPriStartDiff" class="mr-2">{{ getDiagDataCfg('wtPriStartDiff').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="wtPriEndDiff" ref="wtPriEndDiff" :min="-100" :max="100"
                                            v-model="getDiagDataCfg('wtPriEndDiff').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('wtPriEndDiff').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wtPriEndDiff" class="mr-2">{{ getDiagDataCfg('wtPriEndDiff').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="wtPriStartAT" ref="wtPriStartAT" :min="-100" :max="100"
                                            v-model="getDiagDataCfg('wtPriStartAT').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('wtPriStartAT').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wtPriStartAT" class="mr-2">{{ getDiagDataCfg('wtPriStartAT').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="wtPriEndAT" ref="wtPriEndAT" :min="-100" :max="100"
                                            v-model="getDiagDataCfg('wtPriEndAT').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('wtPriEndAT').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wtPriEndAT" class="mr-2">{{ getDiagDataCfg('wtPriEndAT').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Reglereinstellungen" class="mt-3">
                            <template #icons>
                                <i class="fi fi-rr-temperature bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1 mt-2">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="wtPriPfactor" ref="wtPriPfactor" :min="0.1" :max="100"
                                            v-model="getDiagDataCfg('wtPriPfactor').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('wtPriPfactor').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wtPriPfactor" class="mr-2">{{ getDiagDataCfg('wtPriPfactor').label }}</label>
                                    </span>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="wtPriOnDelay" ref="wtPriOnDelay" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('wtPriOnDelay').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wtPriOnDelay" class="mr-2">{{ getDiagDataCfg('wtPriOnDelay').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="wtPriOffDelay" ref="wtPriOffDelay" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('wtPriOffDelay').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="wtPriOffDelay" class="mr-2">{{ getDiagDataCfg('wtPriOffDelay').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel>
                    </TabPanel>
                    <TabPanel header="Alarme primär" v-if="isMaster">
                        <Panel header="Alarmeinstellungen primär VL-Minimum">
                            <template #icons>
                                <i class="fi fi-rr-alarm-clock bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmVlPriMin" ref="alarmVlPriMin" :min="-50" :max="150"
                                            v-model="getDiagDataCfg('alarmVlPriMin').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmVlPriMin').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlPriMin" class="mr-2">{{ getDiagDataCfg('alarmVlPriMin').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <div class="flex justify-content-center">
                                        <SelectButton v-model="getDiagDataCfg('alarmVlPriMinPrior').value" :options="this.$store.getters.getAlarmPrior" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmVlPriMinDiff" ref="alarmVlPriMinDiff" :min="-150" :max="150"
                                            v-model="getDiagDataCfg('alarmVlPriMinDiff').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmVlPriMinDiff').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlPriMinDiff" class="mr-2">{{ getDiagDataCfg('alarmVlPriMinDiff').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="alarmVlPriMinDelay" ref="alarmVlPriMinDelay" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('alarmVlPriMinDelay').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlPriMinDelay" class="mr-2">{{ getDiagDataCfg('alarmVlPriMinDelay').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Alarmeinstellungen primär VL-Maximum" class="mt-2">
                            <template #icons>
                                <i class="fi fi-rr-alarm-clock bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmVlPriMax" ref="alarmVlPriMax" :min="-50" :max="150"
                                            v-model="getDiagDataCfg('alarmVlPriMax').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmVlPriMax').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlPriMax" class="mr-2">{{ getDiagDataCfg('alarmVlPriMax').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <div class="flex justify-content-center">
                                        <SelectButton v-model="getDiagDataCfg('alarmVlPriMaxPrior').value" :options="this.$store.getters.getAlarmPrior" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmVlPriMaxDiff" ref="alarmVlPriMaxDiff" :min="-150" :max="150"
                                            v-model="getDiagDataCfg('alarmVlPriMaxDiff').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmVlPriMaxDiff').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlPriMaxDiff" class="mr-2">{{ getDiagDataCfg('alarmVlPriMaxDiff').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="alarmVlPriMaxDelay" ref="alarmVlPriMaxDelay" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('alarmVlPriMaxDelay').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlPriMaxDelay" class="mr-2">{{ getDiagDataCfg('alarmVlPriMaxDelay').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Alarmeinstellungen primär Differenztemperatur" class="mt-2">
                            <template #icons>
                                <i class="fi fi-rr-alarm-clock bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmVlPriDiff" ref="alarmVlPriDiff" :min="-50" :max="150"
                                            v-model="getDiagDataCfg('alarmVlPriDiff').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmVlPriDiff').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlPriDiff" class="mr-2">{{ getDiagDataCfg('alarmVlPriDiff').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <div class="flex justify-content-center">
                                        <SelectButton v-model="getDiagDataCfg('alarmVlPriDiffPrior').value" :options="this.$store.getters.getAlarmPrior" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmVlPriDiffDiff" ref="alarmVlPriDiffDiff" :min="-150" :max="150"
                                            v-model="getDiagDataCfg('alarmVlPriDiffDiff').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmVlPriDiffDiff').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlPriDiffDiff" class="mr-2">{{ getDiagDataCfg('alarmVlPriDiffDiff').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="alarmVlPriDiffDelay" ref="alarmVlPriDiffDelay" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('alarmVlPriDiffDelay').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlPriDiffDelay" class="mr-2">{{ getDiagDataCfg('alarmVlPriDiffDelay').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel>
                    </TabPanel>
                    <TabPanel header="Alarme sekundär">
                        <Panel header="Alarmeinstellungen sekundär VL-Minimum">
                            <template #icons>
                                <i class="fi fi-rr-alarm-clock bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmVlSecMin" ref="alarmVlSecMin" :min="-50" :max="150"
                                            v-model="getDiagDataCfg('alarmVlSecMin').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmVlSecMin').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlSecMin" class="mr-2">{{ getDiagDataCfg('alarmVlSecMin').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <div class="flex justify-content-center">
                                        <SelectButton v-model="getDiagDataCfg('alarmVlSecMinPrior').value" :options="this.$store.getters.getAlarmPrior" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmVlSecMinDiff" ref="alarmVlSecMinDiff" :min="-150" :max="150"
                                            v-model="getDiagDataCfg('alarmVlSecMinDiff').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmVlSecMinDiff').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlSecMinDiff" class="mr-2">{{ getDiagDataCfg('alarmVlSecMinDiff').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="alarmVlSecMinDelay" ref="alarmVlSecMinDelay" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('alarmVlSecMinDelay').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlSecMinDelay" class="mr-2">{{ getDiagDataCfg('alarmVlSecMinDelay').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Alarmeinstellungen sekundär VL-Maximum" class="mt-2">
                            <template #icons>
                                <i class="fi fi-rr-alarm-clock bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmVlSecMax" ref="alarmVlSecMax" :min="-50" :max="150"
                                            v-model="getDiagDataCfg('alarmVlSecMax').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmVlSecMax').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlSecMax" class="mr-2">{{ getDiagDataCfg('alarmVlSecMax').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <div class="flex justify-content-center">
                                        <SelectButton v-model="getDiagDataCfg('alarmVlSecMaxPrior').value" :options="this.$store.getters.getAlarmPrior" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmVlSecMaxDiff" ref="alarmVlSecMaxDiff" :min="-150" :max="150"
                                            v-model="getDiagDataCfg('alarmVlSecMaxDiff').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmVlSecMaxDiff').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlSecMaxDiff" class="mr-2">{{ getDiagDataCfg('alarmVlSecMaxDiff').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="alarmVlSecMaxDelay" ref="alarmVlSecMaxDelay" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('alarmVlSecMaxDelay').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlSecMaxDelay" class="mr-2">{{ getDiagDataCfg('alarmVlSecMaxDelay').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Alarmeinstellungen sekundär Differenztemperatur" class="mt-2">
                            <template #icons>
                                <i class="fi fi-rr-alarm-clock bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmVlSecDiff" ref="alarmVlSecDiff" :min="-50" :max="150"
                                            v-model="getDiagDataCfg('alarmVlSecDiff').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmVlSecDiff').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlSecDiff" class="mr-2">{{ getDiagDataCfg('alarmVlSecDiff').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <div class="flex justify-content-center">
                                        <SelectButton v-model="getDiagDataCfg('alarmVlSecDiffPrior').value" :options="this.$store.getters.getAlarmPrior" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputNumber id="alarmVlSecDiffDiff" ref="alarmVlSecDiffDiff" :min="-150" :max="150"
                                            v-model="getDiagDataCfg('alarmVlSecDiffDiff').value" mode="decimal"
                                            :suffix="` ${getDiagDataCfg('alarmVlSecDiffDiff').unit}`"
                                            :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlSecDiffDiff" class="mr-2">{{ getDiagDataCfg('alarmVlSecDiffDiff').label }}</label>
                                    </span>
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="alarmVlSecDiffDelay" ref="alarmVlSecDiffDelay" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('alarmVlSecDiffDelay').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmVlSecDiffDelay" class="mr-2">{{ getDiagDataCfg('alarmVlSecDiffDelay').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel>
                    </TabPanel>
                    <TabPanel header="Alarme extern" v-if="isMaster">
                        <Panel header="Alarmeinstellungen sekundär VL-Minimum">
                            <template #icons>
                                <i class="fi fi-rr-alarm-clock bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field col flex justify-content-center">
                                        <div class="flex align-items-center mt-3">
                                            <InputSwitch v-model="this.getDiagDataCfg('extAlarmLogic').value" /><span class="ml-2">{{ this.getDiagDataCfg('extAlarmLogic').label }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="flex justify-content-center">
                                        <SelectButton v-model="getDiagDataCfg('alarmExternPrior').value" :options="this.$store.getters.getAlarmPrior" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                </div>
                                <div class="field col">
                                    <span class="p-float-label mr-2">
                                        <InputMask id="alarmExternDelay" ref="alarmExternDelay" mask="99:99:99"
                                            placeholder="" slotChar="hh:mm:ss"
                                            v-model="this.getDiagDataCfg('alarmExternDelay').value"
                                            @focus="focusElement" class="p-inputtext-lg w-full" />
                                        <label for="alarmExternDelay" class="mr-2">{{ getDiagDataCfg('alarmExternDelay').label }}</label>
                                    </span>
                                </div>
                            </div>
                        </Panel>
                    </TabPanel>
                    <TabPanel header="Sensoreinstellungen" v-if="isMaster">
                        <Panel header="Filtereinstellungen" class="mt-0">
                            <template #icons>
                                <i class="fi fi-rr-settings bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="tempFilterTime" ref="tempFilterTime" :min="0" :max="100000"
                                                v-model="this.getDiagDataCfg('tempFilterTime').value" mode="decimal"
                                                :suffix="` ${this.getDiagDataCfg('tempFilterTime').unit}`"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="tempFilterTime" class="mr-2">{{ this.getDiagDataCfg('tempFilterTime').label }}</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="tempFilterValue" ref="tempFilterValue" :min="0" :max="1"
                                                v-model="this.getDiagDataCfg('tempFilterValue').value" mode="decimal"
                                                :suffix="` ${this.getDiagDataCfg('tempFilterValue').unit}`"
                                                :minFractionDigits="3" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="tempFilterValue" class="mr-2">{{ this.getDiagDataCfg('tempFilterValue').label }}</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="calcFilterTime" ref="calcFilterTime" :min="0" :max="100000"
                                                v-model="this.getDiagDataCfg('calcFilterTime').value" mode="decimal"
                                                :suffix="` ${this.getDiagDataCfg('calcFilterTime').unit}`"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="calcFilterTime" class="mr-2">{{ this.getDiagDataCfg('calcFilterTime').label }}</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="calcFilterValue" ref="calcFilterValue" :min="0" :max="10000"
                                                v-model="this.getDiagDataCfg('calcFilterValue').value" mode="decimal"
                                                :suffix="` ${this.getDiagDataCfg('calcFilterValue').unit}`"
                                                :minFractionDigits="3" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="calcFilterValue" class="mr-2">{{ this.getDiagDataCfg('calcFilterValue').label }}</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="filterTypeVlSet" ref="filterTypeVlSet" :min="0" :max="10"
                                                v-model="this.getDiagDataCfg('filterTypeVlSet').value" mode="decimal"
                                                :suffix="` ${this.getDiagDataCfg('filterTypeVlSet').unit}`"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="filterTypeVlSet" class="mr-2">{{ this.getDiagDataCfg('filterTypeVlSet').label }}</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="filterTypeWtSet" ref="filterTypeWtSet" :min="0" :max="10"
                                                v-model="this.getDiagDataCfg('filterTypeWtSet').value" mode="decimal"
                                                :suffix="` ${this.getDiagDataCfg('filterTypeWtSet').unit}`"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="filterTypeWtSet" class="mr-2">{{ this.getDiagDataCfg('filterTypeWtSet').label }}</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Sensorskalierung primär Vorlauf" class="mt-3">
                            <template #icons>
                                <i class="fi fi-rr-settings bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="vlPriSensInMin" ref="vlPriSensInMin" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('vlPriSensInMin').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="vlPriSensInMin" class="mr-2">Sensor IN Untergrenze</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="vlPriSensOutMin" ref="vlPriSensOutMin" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('vlPriSensOutMin').value"
                                                :suffix="` ${this.getDiagDataCfg('vlPriSensOutMin').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="vlPriSensOutMin" class="mr-2">Sensor OUT Untergrenze</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="vlPriSensInMax" ref="vlPriSensInMax" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('vlPriSensInMax').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="vlPriSensInMax" class="mr-2">Sensor IN Obergrenze</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="vlPriSensOutMax" ref="vlPriSensOutMax" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('vlPriSensOutMax').value"
                                                :suffix="` ${this.getDiagDataCfg('vlPriSensOutMax').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="vlPriSensOutMax" class="mr-2">Sensor OUT Obergrenze</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="vlPriSensOffset" ref="vlPriSensOffset" :min="-10000" :max="10000"
                                                v-model="this.getDiagDataCfg('vlPriSensOffset').value" mode="decimal"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="vlPriSensOffset" class="mr-2">Sensor Offset</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="flex justify-content-center">
                                        <SelectButton v-model="getDiagDataCfg('alarmVlPriSensorPrior').value" :options="this.$store.getters.getAlarmPrior" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Sensorskalierung primär Rücklauf" class="mt-3">
                            <template #icons>
                                <i class="fi fi-rr-settings bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="rlPriSensInMin" ref="rlPriSensInMin" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('rlPriSensInMin').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="rlPriSensInMin" class="mr-2">Sensor IN Untergrenze</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="rlPriSensOutMin" ref="rlPriSensOutMin" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('rlPriSensOutMin').value"
                                                :suffix="` ${this.getDiagDataCfg('rlPriSensOutMin').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="rlPriSensOutMin" class="mr-2">Sensor OUT Untergrenze</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="rlPriSensInMax" ref="rlPriSensInMax" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('rlPriSensInMax').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="rlPriSensInMax" class="mr-2">Sensor IN Obergrenze</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="rlPriSensOutMax" ref="rlPriSensOutMax" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('rlPriSensOutMax').value"
                                                :suffix="` ${this.getDiagDataCfg('rlPriSensOutMax').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="rlPriSensOutMax" class="mr-2">Sensor OUT Obergrenze</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="rlPriSensOffset" ref="rlPriSensOffset" :min="-10000" :max="10000"
                                                v-model="this.getDiagDataCfg('rlPriSensOffset').value" mode="decimal"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="rlPriSensOffset" class="mr-2">Sensor Offset</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="flex justify-content-center">
                                        <SelectButton v-model="getDiagDataCfg('alarmRlPriSensorPrior').value" :options="this.$store.getters.getAlarmPrior" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Sensorskalierung sekundär Vorlauf" class="mt-3">
                            <template #icons>
                                <i class="fi fi-rr-settings bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="vlSecSensInMin" ref="vlSecSensInMin" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('vlSecSensInMin').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="vlSecSensInMin" class="mr-2">Sensor IN Untergrenze</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="vlSecSensOutMin" ref="vlSecSensOutMin" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('vlSecSensOutMin').value"
                                                :suffix="` ${this.getDiagDataCfg('vlSecSensOutMin').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="vlSecSensOutMin" class="mr-2">Sensor OUT Untergrenze</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="vlSecSensInMax" ref="vlSecSensInMax" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('vlSecSensInMax').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="vlSecSensInMax" class="mr-2">Sensor IN Obergrenze</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="vlSecSensOutMax" ref="vlSecSensOutMax" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('vlSecSensOutMax').value"
                                                :suffix="` ${this.getDiagDataCfg('vlSecSensOutMax').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="vlSecSensOutMax" class="mr-2">Sensor OUT Obergrenze</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="vlSecSensOffset" ref="vlSecSensOffset" :min="-10000" :max="10000"
                                                v-model="this.getDiagDataCfg('vlSecSensOffset').value" mode="decimal"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="vlSecSensOffset" class="mr-2">Sensor Offset</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="flex justify-content-center">
                                        <SelectButton v-model="getDiagDataCfg('alarmVlSecSensorPrior').value" :options="this.$store.getters.getAlarmPrior" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Sensorskalierung sekundär Rücklauf" class="mt-3">
                            <template #icons>
                                <i class="fi fi-rr-settings bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="rlSecSensInMin" ref="rlSecSensInMin" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('rlSecSensInMin').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="rlSecSensInMin" class="mr-2">Sensor IN Untergrenze</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="rlSecSensOutMin" ref="rlSecSensOutMin" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('rlSecSensOutMin').value"
                                                :suffix="` ${this.getDiagDataCfg('rlSecSensOutMin').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="rlSecSensOutMin" class="mr-2">Sensor OUT Untergrenze</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="rlSecSensInMax" ref="rlSecSensInMax" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('rlSecSensInMax').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="rlSecSensInMax" class="mr-2">Sensor IN Obergrenze</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="rlSecSensOutMax" ref="rlSecSensOutMax" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('rlSecSensOutMax').value"
                                                :suffix="` ${this.getDiagDataCfg('rlSecSensOutMax').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="rlSecSensOutMax" class="mr-2">Sensor OUT Obergrenze</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="rlSecSensOffset" ref="rlSecSensOffset" :min="-10000" :max="10000"
                                                v-model="this.getDiagDataCfg('rlSecSensOffset').value" mode="decimal"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="rlSecSensOffset" class="mr-2">Sensor Offset</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="flex justify-content-center">
                                        <SelectButton v-model="getDiagDataCfg('alarmRlSecSensorPrior').value" :options="this.$store.getters.getAlarmPrior" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Sensorskalierung WT1" class="mt-3">
                            <template #icons>
                                <i class="fi fi-rr-settings bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt1SensInMin" ref="wt1SensInMin" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('wt1SensInMin').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt1SensInMin" class="mr-2">Sensor IN Untergrenze</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt1SensOutMin" ref="wt1SensOutMin" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('wt1SensOutMin').value"
                                                :suffix="` ${this.getDiagDataCfg('wt1SensOutMin').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt1SensOutMin" class="mr-2">Sensor OUT Untergrenze</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt1SensInMax" ref="wt1SensInMax" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('wt1SensInMax').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt1SensInMax" class="mr-2">Sensor IN Obergrenze</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt1SensOutMax" ref="wt1SensOutMax" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('wt1SensOutMax').value"
                                                :suffix="` ${this.getDiagDataCfg('wt1SensOutMax').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt1SensOutMax" class="mr-2">Sensor OUT Obergrenze</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt1SensOffset" ref="wt1SensOffset" :min="-10000" :max="10000"
                                                v-model="this.getDiagDataCfg('wt1SensOffset').value" mode="decimal"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt1SensOffset" class="mr-2">Sensor Offset</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="flex justify-content-center">
                                        <SelectButton v-model="getDiagDataCfg('alarmWt1SensorPrior').value" :options="this.$store.getters.getAlarmPrior" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                        <Panel header="Sensorskalierung WT2" class="mt-3">
                            <template #icons>
                                <i class="fi fi-rr-settings bg-bespin fg-lightYellow p-panel-header-icon text-xl"></i>
                            </template>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt2SensInMin" ref="wt2SensInMin" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('wt2SensInMin').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt2SensInMin" class="mr-2">Sensor IN Untergrenze</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt2SensOutMin" ref="wt2SensOutMin" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('wt2SensOutMin').value"
                                                :suffix="` ${this.getDiagDataCfg('wt2SensOutMin').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt2SensOutMin" class="mr-2">Sensor OUT Untergrenze</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt2SensInMax" ref="wt2SensInMax" :min="0" :max="32767"
                                                v-model="this.getDiagDataCfg('wt2SensInMax').value" mode="decimal"
                                                :minFractionDigits="0" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt2SensInMax" class="mr-2">Sensor IN Obergrenze</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt2SensOutMax" ref="wt2SensOutMax" :min="-1000" :max="1000"
                                                v-model="this.getDiagDataCfg('wt2SensOutMax').value"
                                                :suffix="` ${this.getDiagDataCfg('wt2SensOutMax').unit}`"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt2SensOutMax" class="mr-2">Sensor OUT Obergrenze</label>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="formgrid grid p-1">
                                <div class="field col">
                                    <div class="field">
                                        <span class="p-float-label mr-2">
                                            <InputNumber id="wt2SensOffset" ref="wt2SensOffset" :min="-10000" :max="10000"
                                                v-model="this.getDiagDataCfg('wt2SensOffset').value" mode="decimal"
                                                :minFractionDigits="1" :useGrouping="false" locale="de-DE"
                                                @focus="focusElement" class="p-inputtext-lg w-full" />
                                            <label for="wt2SensOffset" class="mr-2">Sensor Offset</label>
                                        </span>
                                    </div>
                                </div>
                                <div class="field col">
                                    <div class="flex justify-content-center">
                                        <SelectButton v-model="getDiagDataCfg('alarmWt2SensorPrior').value" :options="this.$store.getters.getAlarmPrior" optionLabel="name" optionValue="value" dataKey="value" aria-labelledby="name">
                                            <template #option="slotProps">
                                                <span class="flex justify-content-center mx-auto" v-tooltip="slotProps.option.name"><i :class="slotProps.option.icon" class="text-xl icon-inline"></i></span>
                                            </template>
                                        </SelectButton>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                    </TabPanel>
                    <TabPanel header="Alarmausgang" v-if="isMaster">
                        <widgetAlarmOutput :value="this.getDiagDataCfg('alarmAssignedOutput')" @setOutput="($value) => {this.getDiagDataCfg('alarmAssignedOutput').value = $value}"></widgetAlarmOutput>
                    </TabPanel>
                </TabView>
            </div>
            <template #footer>
                <widgetDialogFooter :widgetName="`${this.$options.name}_misc`" :department="moduleDepartment.key" :exchange="true" format="json"
                    @diagAbort="diagToggleMisc"
                    @diagSave="saveDiag('misc')"
                    @import="($value) => {this.nodeDataCfg = $value}"
                    :exportObject="this.nodeDataCfg"
                ></widgetDialogFooter>
            </template>
        </Dialog>

        <div v-if="!isLoading">
            <div class="flex justify-content-between align-items-center p-0 flex-wrap">
                <div class="flex justify-content-start align-items-center p-0">
                    <moduleIconEnat :icon="moduleData.metadata.icon" :alarmStatus="alarmStatus" :alarmQueue="alarmQueue" @toogleAlarmOverlay="toogleAlarmOverlay"></moduleIconEnat>
                    <div class="hidden sm:flex mt-1 ml-2">
                        <widget-mini-progress label="WT1" :value="getModuleValue('OUT_WT1Stellung')"></widget-mini-progress>
                        <widget-mini-progress label="WT2" :value="getModuleValue('OUT_WT2Stellung')"></widget-mini-progress>
                    </div>
                    <div class="flex flex-column mt-3">

                    </div>
                </div>
                <div class="flex justify-content-end align-items-center p-0">
                    <widget-header :value="this.getModuleValue('OUT_SensSecVl')" :moduleData="this.moduleData" @showChart="showChart('value1')" :fgColor="fontColor" />
                </div>
            </div>

            <div class="stats flex mt-1">
                <!-- <div class="left flex flex-column"> -->
                <div class="left">
                    <ul class="widget-list">
                        <Widget_rowValues2 :title="'Vorlauf/Rücklauf pri.'" :value1="this.getModuleValue('OUT_SensPriVl')" :value2="this.getModuleValue('OUT_SensPriRl')" v-if="this.getModuleValue('CFG.wtPriControlEnable').value"></Widget_rowValues2>
                        <Widget_rowValues2 :title="'Vorlauf/Rücklauf sek.'" :value1="this.getModuleValue('OUT_SensSecVl')" :value2="this.getModuleValue('OUT_SensSecRl')"></Widget_rowValues2>
                        <Widget_rowValues2 :title="'WT1/WT2 Temperatur'" :value1="this.getModuleValue('OUT_SensWt1')" :value2="this.getModuleValue('OUT_SensWt2')"></Widget_rowValues2>
                        <Widget_rowValues2 :title="'WT1 Stellung Ist/Soll'" :value1="this.getModuleValue('OUT_WT1Stellung')" :value2="this.getModuleValue('OUT_WT1StellungSoll')"></Widget_rowValues2>
                        <Widget_rowValues2 :title="'WT2 Stellung Ist/Soll'" :value1="this.getModuleValue('OUT_WT2Stellung')" :value2="this.getModuleValue('OUT_WT2StellungSoll')"></Widget_rowValues2>
                    </ul>
                </div>
                <div class="right flex flex-column">
                    <ul class="widget-list">
                        <Widget_rowValues2 :title="'Sollwert/Primärregelung'" :value1="this.getModuleValue('OUT_SetpointCalc')" :value2="this.getModuleValue('OUT_PriControl')"></Widget_rowValues2>
                        <Widget_rowValues2 :title="'RL-MAX Begr.'" :value1="this.getModuleValue('OUT_MaxreturnTemp')" :value2="this.getModuleValue('OUT_Maxreturn')"></Widget_rowValues2>
                    </ul>    
                    <div class="flex flex-wrap">
                        <div class="flex-1 align-items-center justify-content-center mt-3">
                            <button-enat title="Einstellungen" subtitle="Alarme, Meldungen" icon="fi fi-rr-settings" fgColor="yellow" bgColor="darkRed"
                                @click="toggleOP($event, 'misc')" >
                            </button-enat>
                        </div>
                    </div>
                    <div class="flex flex-wrap mt-2">
                        <div class="flex-1 align-items-center justify-content-center mr-1 mt-1">
                            <valuebox-enat title="SEQ" :value="getModuleValueStr('OUT_SEQ')" :moduleData="moduleData" icon="fi fi-rr-dice-six" />
                        </div>
                        <div class="flex-1 align-items-center justify-content-center mr-1 mt-1">
                            <valuebox-enat title="ASK" :value="askText" :moduleData="moduleData" icon="fi fi-rr-unlock" />
                        </div>
                    </div>
                </div>
            </div>
            <textbox-enat title="Status" :value="currentStatusStr" :moduleData="moduleData" icon="fi fi-rr-comment-alt" />
        </div>
        <Dialog 
            v-model:visible="showDiagName"
            :closable="false"
            :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
            :style="{ width: '450px' }"
            :modal="true"
            class="p-fluid"
        >
            <template #header>
                <p class="nice-font"><i class="fi fi-rr-text"></i><span class="pl-1 mt-1">Bezeichnung ändern</span></p>
            </template>
            <div @keydown.esc="hideNameDiag" @keydown.enter="saveNameDiag(changeDiagName)">
                <Panel>
                    <div class="grid p-fluid">
                        <div class="col-12 pl-5 pr-5">
                            <span class="p-float-label mr-2">
                                <InputText id="periodName" ref="periodName" v-model="changeDiagName.value" locale="de-DE" class="nice-font inputtext-param text-center text-2xl" />
                                <label for="periodName" class="mr-2">Bezeichnung</label>
                            </span>
                        </div>
                    </div>
                </Panel>
            </div>
            <template #footer>
            <Button label="Abbrechen" icon="pi pi-times" class="p-button-text" @click="hideNameDiag" />
            <Button label="Speichern" icon="pi pi-check" class="p-button-text" @click="saveNameDiag(changeDiagName)" />
            </template>
        </Dialog>
        <div v-if="entryDialog === true">
            <dialog-io-single v-bind:showDialog="entryDialog" :dialogObj="ioObj" v-bind:dialogData="ioDialogData"
                @entrySave="
                    ($value) => {
                        changeVal($value);
                    }
                " @entryAbort="hideDialog()"></dialog-io-single>
        </div>
        <div v-if="entryDialog === true">
            <dialog-io-single v-bind:showDialog="entryDialog" :dialogObj="ioObj" v-bind:dialogData="ioDialogData"
                @entrySave="
                    ($value) => {
                        changeVal($value);
                    }
                " @entryAbort="hideDialog()"></dialog-io-single>
        </div>
        <dialog-chart-single :icon="getModuleValue('OUT_SensSecVl').icon" :node="getModuleValue('OUT_SensSecVl')" v-bind:show="showChart1" @chart-close="showChart1 = false"></dialog-chart-single>
        <dialog-chart-single :icon="getModuleValue('OUT_WT1Stellung').icon" :node="getModuleValue('OUT_WT1Stellung')" v-bind:show="showChartWt1" @chart-close="showChartWt1 = false"></dialog-chart-single>
        <dialog-chart-single :icon="getModuleValue('OUT_WT2Stellung').icon" :node="getModuleValue('OUT_WT2Stellung')" v-bind:show="showChartWt2" @chart-close="showChartWt2 = false"></dialog-chart-single>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import store from '@/store';
import { mapGetters, mapActions } from 'vuex';
import helpers from '@/helpers';
import { parseNode, setOpcValueToast } from '@/helpers';
import SocketioService from '@/services/socketioService.js';
import Widget_rowValues2 from '@/components/fragments/widget_rowValues2.vue';
import dialogChartSingle from '@/components/dialog/chartSingle.vue';
import widgetMiniProgress from '@/components/fragments/widgetMiniProgress.vue';
import widgetAlarmOutput from '@/components/fragments/widgetAlarmOutput.vue';
import widgetDialogFooter from '@/components/fragments/widgetDialogFooter.vue';
import moduleIconEnat from '@/components/fragments/moduleIconEnat.vue';
import widgetTitleBar from '@/components/fragments/widgetTitleBar.vue';
// import widgetTimeSet from '@/components/fragments/widgetTimeSet.vue';

export default defineComponent({
    name: 'widgetHeatingFwController',
    setup() { },
    components: {
        Widget_rowValues2,
        dialogChartSingle,
        widgetMiniProgress,
        widgetAlarmOutput,
        widgetDialogFooter,
        moduleIconEnat,
        widgetTitleBar,
    },
    props: {
        content: {
            type: null,
            required: true,
        },
        dragObj: {
            type: null,
            required: false,
        },
        valueObj: {
            type: null,
            required: false,
        },
        dataObj: {
            type: null,
            required: false,
        },
        styleObj: {
            type: null,
            required: false,
        },
        createdLayout: {
            type: Boolean,
            required: false,
        },
        readyLayout: {
            type: Boolean,
            required: false,
        },
    },
    watch: {
        createdLayout() {
            this.watchCreatedLayout();
        },
        readyLayout() {
            this.watchLayout();
        },
        '$store.getters.getPageData.editMode': function () {
            this.checkEditMode();
        },
        // nodeEntry: {
        //     handler: function(entry) {
        //         // this.filterParameters();
        //         // if (Array.isArray(entries) && entries.length > 0) {
        //         //     this.loading = false;
        //         // } else {
        //         //     this.loading = true;
        //         // }
        //     },
        //     deep: true
        // }
    },
    computed: {
        ...mapGetters({
            editMode: 'getEditMode',
            getNodeWidget: 'getNodeWidget',
            getOneDepartment: 'types/getOneDepartment',
            getOneCategory: 'types/getOneCategory',
            getHeatFwSeq: 'types/getHeatFwSeq',
            getIoTree: 'getIoTree',
            getStyleColors: 'getStyleColors',
            getStylePatterns: 'getStylePatterns',
            getModules: 'opcua/getModules',
            getModule: 'opcua/getModule',
            getNode: 'opcua/getNode',
            getModuleFetched: 'opcua/getModuleFetched',
            isMaster: 'auth/isMaster',
        }),
        isLoading: function() {
            if (!this.moduleData || !this.getModuleFetched(this.moduleHash) || this.loading) return true;
            return false;
        },
        
        connectedModule: function () {
            if (this.content.data.module) {
                return this.content.data.module;
            }
            return null;
        },
        moduleData: function () {
            if (this.connectedModule) {
                const module = this.getModule(this.connectedModule);
                if (module) return module;
            }
            return null;
        },
        moduleHash: function () {
            if (this.moduleData !== null) {
                if (this.moduleData.source.server !== null && this.moduleData.source.identifier !== null) {
                    return `${this.moduleData.source.server}@${this.moduleData.source.identifier}`
                }
            }
            return null;
        },
        moduleDepartment: function () {
            if (this.moduleData !== null) {
                if (this.moduleData.metadata.department !== null) {
                    return this.getOneDepartment(this.moduleData.metadata.department);
                }
            }
            return { key: store.getters.getNoval, label: store.getters.getNoval };
        },
        moduleCategory: function () {
            if (this.moduleData !== null) {
                if (this.moduleData.metadata.category !== null) {
                    return this.getOneDepartment(this.moduleData.metadata.category);
                }
            }
            return { key: store.getters.getNoval, label: store.getters.getNoval };
        },
        componentName: function () {
            if (this.content.name !== undefined) {
                return this.content.name;
            } else {
                return '???';
            }
        },
        componentLabel: function () {
            if (this.content.label !== undefined) {
                return this.content.label;
            } else if (this.moduleData !== null && this.moduleData.metadata.label) {
                return this.moduleData.metadata.label;
            } else {
                return store.getters.getNoval;
            }
        },
        componentContent: function () {
            if (this.content.content !== undefined) {
                return this.content.content;
            } else {
                return '???';
            }
        },
        componentStyle: function () {
            if (this.content.style && this.content.style !== 'standard') {
                let background = `bg-${this.content.style.background}`;
                if (this.alarmStatus > 0) background = 'alarm';
                return `box ptrn-${this.content.style.pattern} ${background} fg-${this.content.style.foreground}`;
            } else {
                return '';
            }
        },
        fontColor: function () {
            if (this.content.style && this.content.style.foreground) {
                return `fg-${this.content.style.foreground}`;
            }
            return 'gray';
        },
        icon: function () {
            if (this.alarmStatus === 0) {
                return this.moduleData.metadata.icon
            } else {
                return `${this.moduleData.metadata.icon} fg-red pulse-loop cursor-pointer bg-lightCrimson`;
            }
        },
        alarmEntriesCount: function () {
            if (this.getModuleValue(`AlarmEntriesCount`).value > 0) {
                return this.getModuleValue(`AlarmEntriesCount`).value;
            } else {
                return 0;
            }
        },
        alarmStatus: function () {
            let alarmCount = this.alarmEntriesCount;
            for (let i=0; i<this.alarmEntriesCount; i++) {
                // console.log(this.getModuleValue(`AlarmEntries[${i}].OUT_AlarmState`));
                if (this.getModuleValue(`AlarmEntries[${i}].OUT_AlarmState`).value <= 0) {
                    alarmCount -= 1;
                }
            }
            return alarmCount;
        },
        alarmQueue: function () {
            let alarmCount = this.alarmEntriesCount;
            for (let i=0; i<this.alarmEntriesCount; i++) {
                // console.log(this.getModuleValue(`AlarmEntries[${i}].OUT_AlarmState`));
                if (this.getModuleValue(`AlarmEntries[${i}].OUT_AlarmState`).value === 0) {
                    alarmCount -= 1;
                }
            }
            return alarmCount;
        },
        alarmList: function () {
            let activeAlarms = [];
            for (let i=0; i<this.alarmEntriesCount; i++) {
                if (this.getModuleValue(`AlarmEntries[${i}].OUT_AlarmState`).value !== 0) {
                    const alarm = {
                        label: this.getModuleValue(`AlarmEntries[${i}].CFG.alarmLabel`).value,
                        state: this.getModuleValue(`AlarmEntries[${i}].OUT_AlarmState`).value
                    }
                    activeAlarms.push(alarm);
                }
            }
            return activeAlarms;
        },
        alarmTicker: function () {
            let alarmStr = '';
            for (let i=0; i<this.alarmEntriesCount; i++) {
                if (this.getModuleValue(`AlarmEntries[${i}].OUT_AlarmState`).value > 0) {
                    alarmStr += `🔴 ${this.getModuleValue(`AlarmEntries[${i}].CFG.alarmLabel`).value} `;
                }
            }
            return alarmStr;
        },
        orientationStr1: function () {
            return helpers.ventOrientation(this.getModuleValue('CFG.ausrichtung').value, 1);
        },
        orientationStr2: function () {
            return helpers.ventOrientation(this.getModuleValue('CFG.ausrichtung').value, 2);
        },
        currentStatusStr: function () {
            return this.getModuleValue('OUT_StatusStr').value;
        },
        currentPositionFloat1: function () {
            return parseFloat(this.getModuleValue('OUT_Stellung_1_Aktuell').value);
        },
        currentPositionFloat2: function () {
            return parseFloat(this.getModuleValue('OUT_Stellung_2_Aktuell').value);
        },
        pumpIcon: function () {
            if (this.getModuleValue('OUT_UWP').value) {
                return `pulse-loop fi-rr-arrow-circle-right fg-green`;
            } else {
                return `fi-rr-arrow-circle-right`;
            }
        },
        askText: function () {
            if (this.getModuleValue('OUT_ASK').value === true) {
                return `geöffnet`;
            } else {
                return `geschlossen`;
            }
        },
        periodIndex: function () {
            return this.getModuleValue('OUT_AktPeriodeHzg.PeriodIndex').value;
        },
        periodCheck: function () {
            if (this.nodeDataPeriods.length > 0) {
                let cnt = 0;
                this.nodeDataPeriods.forEach((period) => {
                    const result = period.find(entry => entry.displayName === 'EnablePeriod');
                    if (result) {
                        if (result.value === true) cnt+=1;
                    }
                });
                if (cnt > 0) return false;
            }
            return true;
        },
    },
    data() {
        return {
            loading: false,
            showChart1: false,
            showChartWt1: false,
            showChartWt2: false,
            saveWait: false,
            dialogLoading: false,
            entryDialog: false,
            valveDialog: false,
            ioDialogData: {},
            ioObj: {},
            timeSetGrp: null,
            nodeData: [],
            nodeDataOld: [],
            nodeDataCfg: [],
            nodeDataCfgOld: [],
            nodeDataPeriods: [],
            nodeDataPeriodsOld: [],
            showDiagName: false,
            currentGrp: {
                name: null,
                label: null,
                enable: null,
                timeSet: null,
                limits: {},
                controller: {},
            },
            node: null,
            lala: null,
            showDiagPeriods: false,
            showDiagMisc: false,
            submitted: false,
            selectedKey: {},
            expandedKeys: {},
            items: [],
            items1: [
                {
                    label: 'Allgemeine Einstellungen',
                    icon: 'fi fi-rr-settings-sliders',
                    command: () => {
                        // this.editValve(this.content);
                        this.toggleOP(null, 'misc');
                    },
                },
            ],
            items2: [
                {
                    separator: true,
                },
                {
                    label: 'Widget Config',
                    icon: 'pi pi-cog',
                    command: () => {
                        this.editEntry(this.content);
                    },
                },
                {
                    label: 'Duplizieren',
                    icon: 'pi pi-clone',
                    command: () => {
                        this.duplicateEntry();
                    },
                },
                {
                    label: 'Löschen',
                    icon: 'pi pi-times',
                    command: () => {
                        this.deleteEntry();
                    },
                },
            ],
        };
    },
    created() {
        this.loading = true;
    },
    mounted() {
        this.checkEditMode();
        if (!this.getModuleFetched(this.moduleHash)) {
            this.loadModule(this.connectedModule).then((module) => {
                const moduleHash = `${module.source.server}@${module.source.identifier}.*`;
                SocketioService.getRedisNodesParam(moduleHash, (err, response) => {
                    if (!err && response) {
                        if (Array.isArray(response) && response.length > 0) {
                            this.setNodesFull(response);
                        }
                    }
                }).then(() => { 
                    if (this.editMode) console.log(`[ENATWIDGET] ${this.moduleHash} : component ready!`);
                    this.setModuleFetched(this.moduleHash);
                    this.loading = false;
                });
            });
        } else {
            this.loading = false;
        }
    },
    methods: {
        ...mapActions({
            loadNode: 'opcua/loadNode',
            loadModule: 'opcua/loadModule',
            setNodesFull: 'opcua/setNodesFull',
            setModuleFetched: 'opcua/setModuleFetched',
        }),
        loadingState(state) {
            if (state) {
                this.loading = true;
            } else {
                this.loading = false;
            }
        },
        getModuleValue(schemeEntry) {
            const key = `${this.moduleHash}.${schemeEntry}`;
            return this.getNode(key);
        },
        getModuleValueStr(schemeEntry) {
            const key = `${this.moduleHash}.${schemeEntry}`;
            const node = this.getNode(key);
            if (typeof node.unit === 'string' && node.unit.length > 0) {
                return `${node.value}${node.unit}`;
            }
            return `${node.value}`;
        },
        getDiagData(key) {
            if (this.nodeData.length > 0) {
                const result = this.nodeData.find(entry => entry.key2 === key);
                return result;
            }
            return null;
        },
        getDiagDataPeriods(index, displayName) {
            if (this.nodeDataPeriods.length > 0 && index >= 0) {
                const result = this.nodeDataPeriods[index].find(entry => entry.displayName === displayName);
                return result;
            }
            return null;
        },
        getDiagDataCfg(displayName) {
            if (this.nodeDataCfg.length > 0 && displayName) {
                const result = this.nodeDataCfg.find(entry => entry.displayName === displayName);
                return result;
            }
            return null;
        },
        watchCreatedLayout() {
            // this.loading = true;
        },
        watchLayout() {
        },
        checkEditMode() {
            if (this.$store.getters.getPageData.editMode) {
                this.items = [...this.items1, ...this.items2];
            } else {
                this.items = [...this.items1];
            }
        },
        clearVals() {
            this.nodeDataCfg = [];
            this.nodeDataCfgOld = [];
            this.nodeDataPeriods = [];
            this.nodeDataPeriodsOld = [];
            this.saveWait = false;
            this.dialogLoading = false;
        },
        updateMap() {
            // this.node = helpers.mapNodes(_.cloneDeep(this.nodeEntry.children), null);
            if (this.node && this.node.size > 0) {
                for (let [key, element] of this.node) {
                    const child = store.getters.getMapValue(element.uuid);
                    this.node.set(key, {...child, value: child.value});
                }
            }
        },
        currentMap() {
            let map = new Map();
            if (this.node && this.node.size > 0) {
                for (let [key, element] of this.node) {
                    const child = store.getters.getMapValue(element.uuid);
                    map.set(key, {...child, value: child.value});
                }
                return map;
            }
            return null;
        },
        getParameter(lvl1, lvl2, index) {
            let parameter = null;
            if (!lvl1) return false;
            if (!lvl2) lvl2 = '';
            if (!isNaN(index)) {
                parameter = this.node.get(lvl1 + '[' + index + '].' + lvl2);
            } else {
                parameter = this.node.get(lvl1 + lvl2);
            }
            return parameter;
        },
        returnChild(childStr) {
            if (typeof childStr == 'string' && this.nodeEntry !== undefined) {
                return helpers.returnChild(this.nodeEntry, childStr);
            } else {
                return null;
            }
        },
        returnParameter(node, key, parameter) {
            return helpers.returnParameter(node, key, parameter);
        },
        returnParameterValue(node, key, parameter, unit) {
            return helpers.returnParameterValue(node, key, parameter, unit);
        },
        timeDialog(time) {
            console.log(time);
        },
        toogleAlarmOverlay(event) {
            this.$refs.alarmOverlay.toggle(event);
        },
        toggle(event) {
            this.$refs.menu.toggle(event);
            // this.this.getModuleValueStatusIOTree();
            // this.getOPCAppTree();
        },
        toggleOP(event, grp) {
            if (grp === 'periods') {
                SocketioService.getRedisNodesParamScaled(`${this.moduleHash}.CFG_Perioden_Vorlauf*`, (err, response) => {
                    if (err || !response) {
                        console.log(`[ENATWIDGET] error fetching params: ${err}`);
                    }
                    else {
                        if (Array.isArray(response) && response.length > 0) {
                            let tmpNodes = [];
                            tmpNodes = JSON.parse(JSON.stringify(response));
                            tmpNodes.forEach((entry) => {
                                if (entry.child0) {
                                    const child = JSON.parse(entry.child0)
                                    if (child.index >= 0) {
                                        if (!Array.isArray(this.nodeDataPeriods[child.index])) {
                                            this.nodeDataPeriods[child.index] = [];
                                        }
                                        this.nodeDataPeriods[child.index].push(entry);
                                    }
                                }
                                // console.log(entry);
                            });
                            this.nodeDataPeriodsOld = JSON.parse(JSON.stringify(this.nodeDataPeriods));
                            console.log(this.nodeDataPeriods);
                            console.log(this.nodeDataPeriodsOld);
                            // console.log(this.getDiagDataHzg(0, 'PeriodName'));
                        }
                    }
                }).then(() => {
                    this.showDiagPeriods = true;
                });        
            } else if (grp === 'periodsVents') {
                SocketioService.getRedisNodesParamScaled(`${this.moduleHash}.Perioden_Lueftung*`, (err, response) => {
                    if (err || !response) {
                        console.log(`[ENATWIDGET] error fetching params: ${err}`);
                    }
                    else {
                        if (Array.isArray(response) && response.length > 0) {
                            let tmpNodes = [];
                            tmpNodes = JSON.parse(JSON.stringify(response));
                            tmpNodes.forEach((entry) => {
                                if (entry.child0) {
                                    const child = JSON.parse(entry.child0)
                                    if (child.index >= 0) {
                                        if (!Array.isArray(this.nodeDataLft[child.index])) {
                                            this.nodeDataLft[child.index] = [];
                                        }
                                        this.nodeDataLft[child.index].push(entry);
                                    }
                                }
                                // console.log(entry);
                            });
                            this.nodeDataLftOld = JSON.parse(JSON.stringify(this.nodeDataLft));
                            console.log(this.nodeDataLft);
                            console.log(this.nodeDataLftOld);
                            // console.log(this.getDiagDataHzg(0, 'PeriodName'));
                        }
                    }
                }).then(() => {
                    this.showDiagVents = true;
                }); 
            } else if (grp === 'misc') {
                SocketioService.getRedisNodesParamScaled(`${this.moduleHash}.CFG*`, (err, response) => {
                    if (err || !response) {
                        console.log(`[ENATWIDGET] error fetching params: ${err}`);
                    }
                    else {
                        if (Array.isArray(response) && response.length > 0) {
                            this.nodeDataCfg = JSON.parse(JSON.stringify(response));
                            this.nodeDataCfgOld = JSON.parse(JSON.stringify(response));
                        }
                            console.log(this.nodeDataCfg);
                            console.log(this.nodeDataCfgOld);
                            // console.log(this.getDiagDataHzg(0, 'PeriodName'));
                        }
                }).then(() => {
                    this.showDiagMisc = true;
                }); 
            }
        },
        diagTogglePeriods() {
            if (this.showDiagPeriods) {
                this.showDiagPeriods = false;
            } else {
                this.showDiagPeriods = true;
            }
            this.hideOP();
        },
        diagToggleMisc() {
            if (this.showDiagMisc) {
                this.showDiagMisc = false;
            } else {
                this.showDiagMisc = true;
            }
            this.hideOP();
        },
        hideOP() {
            this.clearVals();
        },
        saveDiag(diag) {
            if (diag) {
                const saveArray = [];
                this.dialogLoading = true;
                this.saveWait = true;

                if (diag === 'periods' && !this.periodCheck) {
                    console.log(this.nodeDataPeriods);
                    console.log(this.nodeDataPeriodsOld);
                    const flatHzg = this.nodeDataPeriods.flatMap(innerArr => innerArr);
                    const flatHzgOld = this.nodeDataPeriodsOld.flatMap(innerArr => innerArr);
                    console.log(flatHzg);
                    console.log(flatHzgOld);

                    flatHzg.forEach((obj1) => {
                    // Find the corresponding object in arr2
                    const obj2 = flatHzgOld.find((item) => item.identifier === obj1.identifier);
                    
                    // If the object is found, compare the values
                    if (obj2) {
                        if (obj1.value !== obj2.value) {
                            const entry = parseNode(obj1, true);
                            saveArray.push(entry);
                        } else if ('plusminus' in obj2 && 'plusminus' in obj1) {
                            if (obj2.plusminus !== obj1.plusminus) {
                                const entry = parseNode(obj1, true);
                                saveArray.push(entry);
                            }
                        }
                    }
                    });
                } else if (diag === 'periodsLft') {
                    console.log(this.nodeDataLft);
                    console.log(this.nodeDataLftOld);
                    const flatHzg = this.nodeDataLft.flatMap(innerArr => innerArr);
                    const flatHzgOld = this.nodeDataLftOld.flatMap(innerArr => innerArr);
                    console.log(flatHzg);
                    console.log(flatHzgOld);

                    flatHzg.forEach((obj1) => {
                    // Find the corresponding object in arr2
                    const obj2 = flatHzgOld.find((item) => item.identifier === obj1.identifier);
                    
                    // If the object is found, compare the values
                    if (obj2) {
                        if (obj1.value !== obj2.value) {
                            const entry = parseNode(obj1, true);
                            saveArray.push(entry);
                        } else if ('plusminus' in obj2 && 'plusminus' in obj1) {
                            if (obj2.plusminus !== obj1.plusminus) {
                                const entry = parseNode(obj1, true);
                                saveArray.push(entry);
                            }
                        }
                    }
                    });
                } else if (diag === 'misc') {
                    console.log(this.nodeDataCfg);
                    console.log(this.nodeDataCfgOld);
                    this.nodeDataCfg.forEach((obj1) => {
                    // Find the corresponding object in arr2
                    const obj2 = this.nodeDataCfgOld.find((item) => item.identifier === obj1.identifier);
                    
                    // If the object is found, compare the values
                    if (obj2) {
                        if (obj1.value !== obj2.value) {
                            const entry = parseNode(obj1, true);
                            saveArray.push(entry);
                        } else if ('plusminus' in obj2 && 'plusminus' in obj1) {
                            if (obj2.plusminus !== obj1.plusminus) {
                                const entry = parseNode(obj1, true);
                                saveArray.push(entry);
                            }
                        }
                    }
                    });
                }
                
                // console.log(saveArray);
                if (saveArray.length > 0) {
                    SocketioService.setOpcValue(saveArray, (err, response) => {
                        if (err) {
                            console.log(err);
                        } else {
                            console.log(response);
                            setOpcValueToast(response, this.$root);
                            this.dialogLoading = false;
                            if (diag === 'periods') this.showDiagPeriods = false;
                            if (diag === 'misc') this.showDiagMisc = false;
                            this.hideOP();
                        }
                    });
                } else {
                    if (diag === 'periods' && !this.periodCheck) {
                        this.saveDiagNoChanges();
                        this.showDiagPeriods = false;
                    } else if (diag === 'periods' && this.periodCheck) {
                        this.saveDiagNoPeriods();
                    } else if (diag === 'misc') {
                        this.saveDiagNoChanges();
                        this.showDiagMisc = false;
                    }
                }
            }
        },
        saveDiagNoChanges() {
            setOpcValueToast(null, this.$root);
            this.dialogLoading = false;
            this.hideOP();
        },
        saveDiagNoPeriods() {
            this.$toast.add({
                severity: 'warn',
                summary: 'Eine Periode aktivieren!',
                detail: 'Es muss zumindest eine Periode aktiviert werden.',
                life: 3000,
            });
            this.dialogLoading = false;
            this.saveWait = false;
        },
        toogleNameDiag(name) {
            this.changeDiagName = JSON.parse(JSON.stringify(name));
            this.showDiagName = true;
        },
        hideNameDiag() {
            this.changeDiagName = null;
            this.showDiagName = false;
        },
        saveNameDiag(node) {
            console.log(node);
            if (node.child0) {
                const child = JSON.parse(node.child0);
                if (child.index >= 0) {
                    console.log(child.index)
                    let obj2 = null;
                    obj2 = this.nodeDataPeriods[child.index].find((item) => item.identifier === node.identifier);
                    if (obj2) {
                        if (typeof this.changeDiagName.value === 'string' && this.changeDiagName.value.length > 0) {
                            obj2.value = this.changeDiagName.value;
                        }
                        console.log(obj2);
                    }
                }
            }
            this.hideNameDiag();
        },
        focusElement(event) {
            if (event !== undefined) {
                event.target.select();
            }
        },
        hideDialog() {
            this.entryDialog = false;
            this.submitted = false;
            // clearInterval(this.intval_Value);
            // this.getUserList();
        },
        resetDialogData() {
            this.ioDialogData = {
                style: {},
                components: {},
                data: {},
            };
            this.selectedKey = {};
            this.expandedKeys = {};
        },
        changeVal(ioData) {
            console.log(ioData);
            this.$emit('entrySave', ioData);
        },
        editEntry(ioData) {
            this.ioDialogData = JSON.parse(JSON.stringify(ioData));
            this.ioObj = JSON.parse(JSON.stringify(this.moduleData));
            this.entryDialog = true;
        },
        saveDialog() {
            this.submitted = true;
            if (this.ioDialogData.i) {
                this.$emit('entrySave', this.ioDialogData);
                this.entryDialog = false;
                this.resetDialogData();
            }
        },
        duplicateEntry() {
            this.$emit('entryDuplicate', this.content);
            this.resetDialogData();
        },
        deleteEntry() {
            this.$emit('entryDelete', this.content);
            this.resetDialogData();
        },
        expandNode(node) {
            this.expandedKeys[node.key] = true;
            if (node.children && node.children.length) {
                for (let child of node.children) {
                    this.expandNode(child);
                    if (child.key === this.ioObj._id) {
                        this.selectedKey[this.ioObj._id] = true;
                    }
                }
            }
        },
        onNodeSelect(node) {
            const newObj = store.getters.getValue(node.key);
            this.selectedKey = node.key;
            this.ioDialogData.data.id = node.key;

            this.$toast.add({
                severity: 'success',
                summary: 'Node ausgewählt',
                detail: newObj.metadata.name + '\n' + this.selectedKey + '\n' + newObj.nodeId,
                life: 3000,
            });
        },
        editValve(ioData) {
            console.log(ioData);
        },
        hideValveDialog() {
            this.valveDialog = false;
            this.submitted = false;
            // clearInterval(this.intval_Value);
            // this.getUserList();
        },
        showChart(value) {
            if (value === 'value1') this.showChart1 = true;
            else if (value === 'wt1') this.showChartWt1 = true;
            else if (value === 'wt2') this.showChartWt2 = true;
        },
    },
});
</script>

<style lang="scss" scoped>
.bounce-enter-active {
    animation: bounce-in 0.5s;
    // transition: opacity .5s;
}

.bounce-leave-active {
    animation: bounce-out 0.5s;
    // transition: opacity .5s;
}

.slide-fade-enter-active {
    transition: all 0.5s ease;
}

.slide-fade-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active for <2.1.8 */
    {
    transform: translateX(10px);
    opacity: 0;
}

.pulse-enter-active {
    animation: pulse 1s;
}

.pulse-leave-active {
    animation: pulse 0.5s;
}

.pulse-loop {
    animation: pulse 1s;
    animation-iteration-count: infinite;
}

.fade-in-enter-active {
    animation: fadeIn linear 2s;
}

.fade-in-leave-active {
    animation: fadeOut linear 2s;
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@keyframes fadeOut {
    0% {
        opacity: 1;
    }

    100% {
        opacity: 0;
    }
}

@keyframes fadeInOut {
    0% {
        // opacity: 0;
    }
    50% {
        // opacity: 1;
        background-color: rgba(117, 18, 0, 0.5);
    }
    100% {
        // opacity: 0;
    }
}

@keyframes pulse {
    0% {
        // transform: scale(1); /* scaling to 0 */
        opacity: 0.8;
        // color: yellowgreen;
        // transform-origin: center center;
        // transform: scaleY(.9);
        text-shadow: black 2px 0 10px;
        transform: scale(0.9);
        /* increasing the size */
    }

    30% {
        transform: scale(1.1);
        /* increasing the size */
        text-shadow: gray 1px 0 10px;
    }

    100% {
        transform: scale(1);
        /* seeting back to initial size */
        opacity: 1;
    }
}

.alarm {
    animation: fadeInOut 1s infinite;
    -webkit-animation: fadeInOut 1s infinite;
}

.grid {
    margin: 0 -0.5em 0 -0.5em !important;
}

.col {
    // line-height: 1.4em !important;
    margin: 0 !important;
    padding: 0 !important;
}

.p-divider {
    margin: 0 !important;
    padding: 0 !important;
}

.box {
    overflow: hidden;
    // text-shadow: 1px 1px 1px black;
}

.card {
    font-family: 'SensorFont';
    line-height: 1.3rem;
    position: relative;
}

.text-normal {
    line-height: 0;
}
// .list-enter-active,
// .list-leave-active {
//   transition: all 0.5s ease;
//   transform: scale(0.7); /* increasing the size */
// }
// .list-enter-from,
// .list-leave-to {
//   opacity: 0;
//   transform: scale(1); /* increasing the size */
// }
.list-enter-active {
    animation: list 1s;
}

.list-leave-active {
    animation: list 0.5s;
}

@keyframes list {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}
.p-togglebutton {
    font-size: 0.8rem;
    line-height: 1rem;
    padding: 0.2rem;
    margin: 0;
}
</style>